import { Tab, TabList, composeRenderProps } from 'react-aria-components'
import type { TabListProps, TabProps } from 'react-aria-components'
import type { VariantProps } from 'tailwind-variants'
import { tv } from 'tailwind-variants'

const tabStyles = tv({
  // TODO: implement outline styles
  base: 'outline-none',
  variants: {
    variant: {
      underlined: [
        'uppercase font-medium text-center text-sm',
        'text-black/60 dark:text-white/80',
        'py-[10px]',
        'cursor-pointer',
      ],
    },
    color: {
      theme: {},
    },
  },
  compoundVariants: [
    {
      variant: 'underlined',
      isSelected: true,
      className: [
        'text-black/100 dark:text-white/100',
        'shadow-[inset_0_-0.1em_black] dark:shadow-[inset_0_-0.1em_white]',
      ],
    },
    {
      variant: 'underlined',
      color: 'theme',
      isSelected: true,
      className: [
        'text-purple-600/100 dark:text-purple-500/100',
        'shadow-[inset_0_-0.1em_theme(colors.purple.600)] dark:shadow-[inset_0_-0.1em_theme(colors.purple.500)]',
      ],
    },
  ],
})
type UITabProps = TabProps &
  Pick<VariantProps<typeof tabStyles>, 'variant' | 'color'> &
  StyleProps
export function UITab(props: UITabProps) {
  const { variant, color, ...rest } = props
  return (
    <Tab
      {...rest}
      className={composeRenderProps(props.className, (className, renderProps) =>
        tabStyles({ ...renderProps, variant, color, className }),
      )}
    />
  )
}

const tabListStyles = tv({
  base: 'flex gap-1',
  variants: {
    orientation: {
      horizontal: 'flex-row',
      vertical: 'flex-col items-start',
    },
    variant: {
      underlined: 'items-center',
    },
  },
})

type UITabListProps<T> = TabListProps<T> &
  Pick<VariantProps<typeof tabListStyles>, 'variant'> &
  StyleProps

export function UITabList<T extends object>(props: UITabListProps<T>) {
  const { variant } = props

  return (
    <TabList
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        tabListStyles({ ...renderProps, variant, className }),
      )}
    ></TabList>
  )
}
